module.exports = "https://cdn-assessment.mathletics.com/app/98/assets/images/de77353ed065a9f9a773c169142998a2.svg";